import React, { useRef, useState } from 'react'
import { motion, useMotionValue, useScroll, useTransform } from 'framer-motion'
import PropTypes from 'prop-types'

const DRAG_BUFFER = 50

const SPRING_OPTIONS = {
  type: 'spring',
  mass: 3,
  stiffness: 400,
  damping: 50,
}

export const ContentPanelPillImage = ({ img, alt, className, imgClassName }) => {
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })
  const translateY = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 1],
    // Into these values:
    ['-5%', '-20%'],
  )

  return (
    <div className={`${className}`} ref={ref}>
      <motion.img
        src={img}
        alt={alt ?? ''}
        style={{ translateY: translateY, transition: { duration: 0.5, ease: 'easeInOut' } }} // backgroundImage: `url(${img})`
        className={`${imgClassName} img_div`}
      />
    </div>
  )
}

export const GalleryAnimatedMovil = ({ images, topTransform }) => {
  const targetRef = useRef(null)
  const [imgIndex, setImgIndex] = useState(0)
  const { scrollYProgress } = useScroll({
    target: targetRef,
  })
  const dragX = useMotionValue(0)
  const onDragEnd = () => {
    const x = dragX.get()

    if (x <= -DRAG_BUFFER && imgIndex < images.length - 1) {
      setImgIndex((pv) => pv + 1)
    } else if (x >= DRAG_BUFFER && imgIndex > 0) {
      setImgIndex((pv) => pv - 1)
    }
  }
  const xAxis = useTransform(
    scrollYProgress,
    [0, 1],
    [topTransform.end, topTransform.start ?? '0%'],
  )
  return (
    <motion.div
      ref={targetRef}
      style={{
        x: xAxis,
        transition: {
          repeat: Infinity,
        },
      }}
      transition={SPRING_OPTIONS}
      className="image-gallery"
    >
      {[...images].map((image, index) => (
        <motion.div
          drag="x"
          dragConstraints={{
            left: 0,
            right: 0,
          }}
          style={{
            x: dragX,
          }}
          animate={{
            translateX: `-${imgIndex * 50}%`,
          }}
          transition={SPRING_OPTIONS}
          onDragEnd={onDragEnd}
          className="rounded-lg image-container"
          key={index}
        >
          <img src={image.url} alt={image.alt ?? ''} className="img_div_slider" />
        </motion.div>
      ))}
    </motion.div>
  )
}

export const GalleryDesktop = ({ gallery, animate_gallery }) => {
  return (
    <div className="image-gallery">
      {gallery.map((image, index) => (
        <motion.div
          style={{
            position: 'relative',
          }}
          transition={{
            duration: 0.6,
            delay: index * 0.3 + 0.3,
          }}
          viewport={{
            once: true,
          }}
          initial={{
            opacity: 0,
            left: '70px',
          }}
          whileInView={{ opacity: 1, left: '0px' }}
          className="image-container"
          exit={{ opacity: 0 }}
          key={index}
        >
          {animate_gallery ? (
            <ContentPanelPillImage
              img={image.url}
              className="rounded-lg"
              imgClassName="animated_img"
              alt={image.alt}
            />
          ) : (
            <img src={image.url} alt={image.alt} className="not_animated_img" />
          )}
        </motion.div>
      ))}
    </div>
  )
}

ContentPanelPillImage.propTypes = {
  img: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
}
GalleryAnimatedMovil.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
  fatherRef: PropTypes.object,
  topTransform: PropTypes.any,
}
GalleryDesktop.propTypes = {
  gallery: PropTypes.arrayOf(PropTypes.object),
  animate_gallery: PropTypes.bool,
}
